import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const useBeforeUnload = (enabled = true) => {
    const history = useHistory();

    // interrupt closing browser tab
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = true;
        };

        if (!enabled) return undefined;
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [enabled]);

    // Use the router blocker only for browser-history transitions. Application
    // navigation is handled by NavigationGuard so it can show the product
    // dialog instead of a second native confirmation.
    useEffect(() => {
        if (!enabled) return undefined;
        const unblock = history.block((_location, action) =>
            action === 'POP' ? 'Are you sure you want to go back? Any unsaved progress will be lost.' : true
        );
        return unblock;
    }, [enabled, history]);
};

export default useBeforeUnload;
